import React from 'react';
import { Form, Input, Button, message } from 'antd';
import CurrencyIcon from '../../Common/CurrencyIcon';
import { dispatch, useGlobalState } from '../../../store/state';
import { RequestFundWithdraw } from '../../../apis/Influencer/Wallet/RequestFundWithdraw';

const { Item } = Form;
const CreditWithdrawForm = () => {
  const [withdrawForm] = Form.useForm();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');

  // note: withdraw available Balance
  const withdrawBalance = (_v) =>{
    console.log('_withdraw', _v);
    const _data= {
      amount: _v.withdrawAmount,
    };

    // @note: triggering fund withdraw
    RequestFundWithdraw(user.accessToken, _data).then(({ response, status })=>{
      console.log('withdraw status', response);
      if (status === 200) {
        console.log('success', response);
        message.success(`Accpeted your withdraw request of INR ${_data.amount}`);
        withdrawForm.resetFields();
        // @TODO: need to implemented balance update to state awaiting api status
        dispatch({
          type: 'SET_COMPANY',
          payload: {
            ...company,
            credit: {
              ...company.credit,
              balance: response.walletbalance ||company.credit.balance,
            },
          },
        });
      } else {
        message.error(`There is some issue with your withdrawal request`);
        // console.log("success",response)
      }
    });
  };
  return (
    <Form
      form={withdrawForm}
      name="withdrawForm"
      layout="horizontal"
      onFinish={withdrawBalance}
      className="bank_details_existing_form"
    >
      <p className="m-0 bank_details_existing_form--title">Withdraw money to your bank account</p>
      <div className="d-flex">
        {user.wallet.balance ?
          <Item
            width={150}
            name="withdrawAmount"
            rules={[
              { required: true, message: 'Please enter amount' },
              ({ getFieldValue }) => ({
                validator (_, value) {
                  const _fval = getFieldValue('withdrawAmount');
                  if (value && (_fval > company.credit.balance)) {
                    return Promise.reject(new Error('Amount is higher than balance'));
                  } else if (value && (_fval <= 1999)) {
                    return Promise.reject(new Error('Amount is must be INR.2000 or higher'));
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input
              disabled={company && company.credit && company.credit.balance >= 1 ? false: true}
              // disabled={user.wallet.balance >= 1 ? false: true}
              width={150}
              maxLength={2}
              size="large"
              prefix={CurrencyIcon()}
              type="number"
              placeholder="Amount"
              className="common_input"
            />
          </Item>:
          null
        }
        <Item className="mb-0">
          <Button
            htmlType="submit"
            size="large"
            className="common_button ml-2 outlined"
            disabled={company && company.credit && company.credit.balance >= 1 ? false: true}
          >
                        Withdraw
          </Button>
        </Item>
      </div>
    </Form>
  );
};

export default CreditWithdrawForm;
